import React from "react";

import {IDecorParamTypeDescriptor} from "../../database/interfaces/paramScript/IParamTypeDescriptor";
import IBoardData from "../../database/interfaces/IBoardData";
import {DatabaseContext} from "../../database/DatabaseHandler";

import Stack from "@mui/material/Stack";
import EdgeListContent from "./EdgeListContent";
import BoardDecorCardContent from "./BoardDecorCardContent";

/**
 * Decor property card content component — vékony orchestrator.
 * A BOARD-oldali logika a BoardDecorCardContent-ben, az ÉL-oldali az
 * EdgeListContent-ben él; a kettő csak a paramValue-n keresztül kommunikál.
 * A renderelési feltételek az eredetivel azonosak.
 */
interface IDecorCardContentProps {
    typeDescriptor: IDecorParamTypeDescriptor;
    paramValue: any;
    onUpdateParamValue: (value: any) => void;
}

const DecorCardContent: React.FC<IDecorCardContentProps> = ({ typeDescriptor, paramValue, onUpdateParamValue }) => {
    const dataContext = React.useContext(DatabaseContext);

    const boardProduct: IBoardData | null = React.useMemo(() => {
        return dataContext.boardData?.findByID(paramValue.BoardProduct) || null;
    }, [dataContext.boardData, paramValue.BoardProduct]);

    const duplungProduct: IBoardData | null = React.useMemo(() => {
        return dataContext.boardData?.findByID(paramValue.DuplungProduct) || null;
    }, [dataContext.boardData, paramValue.DuplungProduct]);

    // A board-hoz tartozó kompatibilis él ID-k
    const compatibleEdgeIds: string[] = React.useMemo(() => {
        return boardProduct?.CompatibleEdgings || [];
    }, [boardProduct]);

    if (!(typeDescriptor && typeDescriptor.board)) return null;
    if (!boardProduct) return null;

    return (
        <Stack direction="column" spacing={1} width="100%">
            <BoardDecorCardContent
                typeDescriptor={typeDescriptor}
                paramValue={paramValue}
                boardProduct={boardProduct}
                duplungProduct={duplungProduct}
                onUpdateParamValue={onUpdateParamValue}
            />
            {typeDescriptor.edge && boardProduct?.EdgeBandable == 1 && (
                <EdgeListContent
                    typeDescriptor={typeDescriptor}
                    paramValue={paramValue}
                    compatibleEdgeIds={compatibleEdgeIds}
                    onUpdateParamValue={onUpdateParamValue}
                />
            )}
        </Stack>
    );
}

export default DecorCardContent;